/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperData = {
    /**
     * Search for objects in an array and create a new object in front of the array.
     * Used for merging BH attributes.
     *
     * @param {Array} array - The array to search in.
     * @param {Function} predicate - The function to test each element.
     * @param {String} name - The name for the new object.
     * @param {String} attribute - The attribute for the new object.
     *
     * @returns {Array} - The new array with the new object in front.
     */
    processArray(array, predicate, name, attribute) {
        const objects = this.findObjects(array, predicate);
        if (objects.length) {
            array = this.removeObjects(array, predicate);
            array.unshift(this.createNewObject(name, attribute, objects));
        }
        return array;
    },
    /**
     * Find objects in an array that match the predicate.
     *
     * @param {Array} array - The array to search in.
     * @param {Function} predicate - The function to test each element.
     *
     * @returns {Array} - The array of matching objects.
     */
    findObjects(array, predicate) {
        return array.filter(predicate);
    },
    /**
     * Remove objects from an array that match the predicate.
     *
     * @param {Array} array - The array to remove objects from.
     * @param {Function} predicate - The function to test each element.
     *
     * @returns {Array} - The new array with the objects removed.
     */
    removeObjects(array, predicate) {
        return array.filter(item => !predicate(item));
    },
    /**
     * Create a new object with the given name, attribute, and options.
     *
     * @param {String} name - The name for the new object.
     * @param {String} attribute - The attribute for the new object.
     * @param {Array} options - The options for the new object.
     *
     * @returns {Object} - The new object.
     */
    createNewObject(name, attribute, options) {
        return {
            name: name,
            attribute: attribute,
            options: options
        };
    }
}

export default liveSearchHelperData;
